export enum OnboardingTemplateType {
    Onboarding = 0,
    Existing = 1
}
